<template>
  <div :class="className" :style="{'background-color': colourCode}"></div>
</template>

<script>
    export default {
        name: "ColourCircle",
        props: {
            colourCode: String,
            className: String
        },
    }
</script>

<style scoped>
  .dot {
    height: 40px;
    width: 40px;
    border: 5px solid #FFF;
    border-radius: 50%;
    display: inline-block;
    top: -20px;
    left: 50%;
    margin-left: -20px;
  }

  .select {
    height: 40px;
    width: 40px;
    border: 5px solid #FFF;
    border-radius: 50%;
  }
</style>
